import { useContext, useEffect, useState } from 'react';
import css3 from '../../Approvals/css/approval-table.module.css';
//../css/approval-table.module.css
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
//import css4 from '../../../Approvals/css/approval-table.module.css';
import css4 from  '../../Approvals/css/approval-table.module.css'
import styled from '@emotion/styled';
import { setAllBatchInvite  } from '../../../../reduxSlice/batchInviteSlice';
import { useDispatch, useSelector } from 'react-redux';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import { FilterDropDown, Loading } from '../../../../ui-components';
import Checkbox from '@mui/material/Checkbox';
interface ReInvite {
        ApplicantId: string;
        FullName?: string;
        Email?: string;
        PhoneNumber?: string;
      }
      // shared types
export interface InterviewFull {
  ApplicantId: string;
  FullName: string;
  Email: string;
  PhoneNumber: string;
  Comment: string;
  HasAttend: boolean;
  IsSucess: boolean;
}


// interface ReInviteTableProps {
//     data: ReInvite[] ;
//     searchData?: string
//     setSearchData: React.Dispatch<React.SetStateAction<string>>
// }

export const DATA_PER_PAGE = 10;
interface ReInviteTableProps {
  data: InterviewFull[];
  searchData: string;
  setSearchData: (v: string) => void;
  selectedIds: string[];
  onSelectionChange: (ids: string[]) => void;
}

const ReInviteTable = ({
  data,
  searchData,
  setSearchData,
  selectedIds,
  onSelectionChange,
}: ReInviteTableProps) => {
  const [activeData, setActiveData] = useState<InterviewFull[]>([]);
  const [pageData, setPageData] = useState<InterviewFull[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageArr, setPageArr] = useState<number[]>([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [localSelected, setLocalSelected] = useState<string[]>([]);

  const DATA_PER_PAGE = 10;

  // handle search change
  const handleSearchInput = (input: string) => {
    setSearchData(input);
    setLocalSelected([]);  // reset selection
    setIsCheckAll(false);
    setCurrentPage(0);
  };

  // when data prop changes, reset pagination etc.
  useEffect(() => {
    setActiveData(data);
    const lastPage = Math.ceil(data.length / DATA_PER_PAGE);
    const arr = Array.from({ length: lastPage }, (_, i) => i);
    setPageArr(arr);
    setPageData(data.slice(0, DATA_PER_PAGE));
    setCurrentPage(0);
    setLocalSelected([]);
    setIsCheckAll(false);
    onSelectionChange([]); // inform parent
  }, [data]);

  // update pageData when currentPage changes
  useEffect(() => {
    const start = currentPage * DATA_PER_PAGE;
    const stop = start + DATA_PER_PAGE;
    setPageData(activeData.slice(start, stop));
  }, [currentPage, activeData]);

  // select all toggle
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsCheckAll(checked);
    if (checked) {
      const idsOnPage = pageData.map(item => item.ApplicantId);
      setLocalSelected(idsOnPage);
      onSelectionChange(idsOnPage);
    } else {
      setLocalSelected([]);
      onSelectionChange([]);
    }
  };

  const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    let newSelected = [...localSelected];
    if (checked) {
      if (!newSelected.includes(id)) newSelected.push(id);
    } else {
      newSelected = newSelected.filter(x => x !== id);
    }
    setLocalSelected(newSelected);
    onSelectionChange(newSelected);

    // also update isCheckAll if needed
    if (newSelected.length === pageData.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  };

  return (
    <>
      <Section1>
        <div className='searchWrapper'>
          <label className={'searchForm'}>
            <span className={'sI'}><SearchIcon /></span>
            <input
              value={searchData}
              onChange={(e) => handleSearchInput(e.target.value)}
              type="text"
              placeholder='Search'
            />
            <button className={'rBtn'} type="button"><ReloadIcon /></button>
          </label>
        </div>
        <span>
          Select All{' '}
          <Checkbox
            id='selectAll'
            onChange={handleSelectAll}
            checked={isCheckAll}
            sx={{ marginBlockEnd: '3px' }}
          />
        </span>
      </Section1>

      {data.length > 0 ? (
        <Table>
          <div className='t-head'>
            <span></span>
            <span>Applicant Id</span>
            <span>Full Name</span>
            <span>Email</span>
            <span>Phone Number</span>
          </div>
          <Tbody>
            {pageData.map(item => (
              <div key={item.ApplicantId}>
                <div>
                  <Checkbox
                    onChange={handleClick}
                    id={item.ApplicantId}
                    checked={localSelected.includes(item.ApplicantId)}
                  />
                </div>
                <span>{item.ApplicantId?.slice(0, 15)}...</span>
                <span>{item.FullName}</span>
                <span>{item.Email}</span>
                <span>{item.PhoneNumber}</span>
              </div>
            ))}
          </Tbody>
          <div className={css3.pagination}>
            <div>
              <button
                className={`${css3.lBtn} ${css3.btn}`}
                onClick={() =>
                  setCurrentPage(prev =>
                    prev === 0 ? (pageArr.at(-1) ?? 0) : prev - 1
                  )
                }
              >
                <LBtn />
              </button>
              {pageArr.map(p => (
                <span
                  key={p}
                  style={
                    p === currentPage
                      ? { backgroundColor: 'var(--activeP-back)', color: 'var(--white-color)' }
                      : {}
                  }
                  onClick={() => setCurrentPage(p)}
                >
                  {p + 1}
                </span>
              ))}
              <button
                className={`${css3.rBtn} ${css3.btn}`}
                onClick={() =>
                  setCurrentPage(prev =>
                    prev === (pageArr.at(-1) ?? 0) ? 0 : prev + 1
                  )
                }
              >
                <RBtn />
              </button>
            </div>
          </div>
        </Table>
      ) : (
        <NoResult>No Results</NoResult>
      )}
    </>
  );
};



const Table = styled.div`
        padding-block-start: 10px;
        & > .table-div{
            display:flex;
            flex-direction:column;
            gap:5px;
            margin-top:10px;
        }
        & > .table-div > div{
            width:100%;
        }
        & .t-head{
            display:grid;
            grid-template-columns: 0.3fr repeat(4,1fr);
            background-color:#E0FAEE;
            padding:15px 10px;
        }
`
const Tbody = styled.div`
        display: flex;
        gap:8px;
        flex-direction: column;
        border-top:2px solid #E2E4E9;
        border-bottom:2px solid #E2E4E9;
        min-height: 250px;

        & > div{
            border-left:2px solid #fff;
            display:grid;
            grid-template-columns: 0.3fr repeat(4,1fr);
            padding:10px 7px;

            & > span {
                display: flex;
                align-items: center;
            }
        }
        & > div:hover{
            border-left-color:#293856;
        }
`

const Section1 = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 46px;
    & span{
        font-size: 16px;
    }

    & .searchWrapper{
        margin-block-start: 1.6px;
        display: flex;
        gap: 10px;
    }

    & .searchForm{
        width: 250px;
        position: relative;
        display: flex;
        align-items: center;
    }

    &   .sI{
        position: absolute;
        left:7px;
    }

    &  .rBtn{
        position: absolute;
        right:7px;
        border:none;
        outline:none;
        background-color: transparent;
        cursor: pointer;
    }
    &   .searchForm > input{
        width:100%;
        outline:none;
        border: 1px solid #E2E4E9;
        padding:15px 30px 15px 30px;
        border-radius: 5px;
}
`

const NoResult = styled.div`
  margin-block-end: 25px;
`

export default ReInviteTable;


